// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb_wrapper":"breadcrumbs_breadcrumb_wrapper__UcPit","active":"breadcrumbs_active__BVJQl"};